// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'


// Define a service using a base URL and expected endpoints
export const eventsApi = createApi({
    reducerPath: 'eventsApi',
    baseQuery: fetchBaseQuery({ baseUrl: 'https://stemm-backend.herokuapp.com/homepage/' }),
    endpoints: (builder) => ({
        getEvents: builder.query({
            query: () => 'eventsinfo',
        }),
        getEventsById: builder.query({
            query: ({ id }) => `eventsinfobyid/${ id }`,
        })
    }),
})


// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetEventsQuery, useGetEventsByIdQuery } = eventsApi